module.exports = __webpack_public_path__ + "img/number-thumb-8.70227882.jpg";